if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      isTmpInlineRelated() {
        return (
          this.classList.contains('related-products') &&
          document.querySelector('.tmp-klarna-widget') &&
          document.querySelector('.tmp-features')
        );
      }

      moveTmpRelatedSection() {
        if (!this.isTmpInlineRelated()) return false;

        const klarnaBlock = document.querySelector('.tmp-klarna-widget')?.closest('.product__block');
        const featuresBlock = document.querySelector('.tmp-features')?.closest('.product__block');
        const sectionWrapper = this.closest('.shopify-section');

        if (!klarnaBlock || !featuresBlock || !sectionWrapper) return false;
        if (klarnaBlock.parentElement !== featuresBlock.parentElement) return false;

        sectionWrapper.classList.add('product__block', 'product__block--tmp-related-products', 'tmp-related-products-inline-host');
        sectionWrapper.style.width = '100%';
        sectionWrapper.style.margin = '14px 0';

        const innerSection = sectionWrapper.querySelector('.section--related-products');
        if (innerSection) {
          innerSection.classList.add('tmp-related-products-inline');
          innerSection.style.width = '100%';
          innerSection.style.maxWidth = 'none';
          innerSection.style.margin = '0';
          innerSection.style.padding = '16px 12px';

          const heading = innerSection.querySelector('.section__heading');
          if (heading) {
            heading.style.fontSize = '18px';
            heading.style.lineHeight = '1.1';
            heading.style.marginBottom = '14px';
          }

          innerSection.querySelectorAll('.product-card__title, .product-card__title a').forEach((title) => {
            title.style.setProperty('color', 'var(--tmp-related-product-title-color, #ffffff)', 'important');
          });

          innerSection.querySelectorAll('.product-card__info .f-price, .product-card__info .f-price-item, .product-card__info .f-price s').forEach((price) => {
            price.style.setProperty('color', 'var(--tmp-related-product-price-color, #ffffff)', 'important');
          });
        }

        klarnaBlock.insertAdjacentElement('afterend', sectionWrapper);
        return true;
      }

      prepareTmpRelatedResponse(recommendations) {
        if (!this.isTmpInlineRelated()) return;

        const productSlider = recommendations.querySelector('product-slider');
        if (productSlider) {
          productSlider.setAttribute('data-items', '2');
          productSlider.setAttribute('data-tablet-items', '2');
        }
      }

      init() {
        this.moveTmpRelatedSection();

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (!recommendations) return;

            this.prepareTmpRelatedResponse(recommendations);

            if (recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations.querySelector('.product-card')) {
              this.moveTmpRelatedSection();
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (recommendations.classList.contains('complementary-products')) {
                this.closest('.product__block')?.remove();
              } else {
                this.closest('.shopify-section')?.remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
